import OInput from './OInput'

export default OInput
